class CartDrawer extends HTMLElement {
  constructor() {
    super();
    var q = this.querySelector.bind(this);
    this._ov = q('[data-cart-drawer-overlay]');
    this._pa = q('[data-cart-drawer-panel]');
    this._lr = q('[data-cart-drawer-live]');
    this._tr = null;
    this._kb = this._kb.bind(this);
    /* Set initial hidden state so assistive tech ignores the closed drawer */
    if (this._pa) this._pa.setAttribute('aria-hidden', 'true');
  }

  connectedCallback() {
    var s = this;
    var closeBtn = s.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { s.close(); });
    if (s._ov) s._ov.addEventListener('click', function () { s.close(); });

    /* Quantity change buttons inside the drawer panel */
    if (s._pa) {
      s._pa.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-qty-btn]');
        if (btn) s.change(btn.dataset.key, +btn.dataset.qty);
      });
    }

    /* Intercept add-to-cart form submissions globally */
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-card-add-form]');
      if (f) { e.preventDefault(); s.add(new FormData(f)); }
    });
  }

  open(triggerEl) {
    this._tr = triggerEl || document.activeElement;
    if (this._ov) this._ov.classList.add('is-open');
    if (this._pa) {
      this._pa.classList.add('is-open');
      this._pa.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._kb);
    /* Focus first interactive element so keyboard users land inside drawer */
    var first = this._pa && this._pa.querySelector('a[href], button:not([disabled])');
    if (first) first.focus();
  }

  close() {
    if (this._ov) this._ov.classList.remove('is-open');
    if (this._pa) {
      this._pa.classList.remove('is-open');
      this._pa.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._kb);
    if (this._tr && this._tr.focus) this._tr.focus();
    this._tr = null;
  }

  /* Focus trap: Escape closes, Tab cycles within panel */
  _kb(e) {
    if (e.key === 'Escape') { this.close(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(
      this._pa.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')
    );
    if (!focusable.length) return;
    var active = document.activeElement;
    /* If focus escaped the panel, pull it back to first element */
    if (focusable.indexOf(active) === -1) { e.preventDefault(); focusable[0].focus(); return; }
    if (e.shiftKey && active === focusable[0]) {
      e.preventDefault();
      focusable[focusable.length - 1].focus();
    } else if (!e.shiftKey && active === focusable[focusable.length - 1]) {
      e.preventDefault();
      focusable[0].focus();
    }
  }

  /* Alias so callers can use either addToCart() or add() */
  add(formData) { this.addToCart(formData); }

  addToCart(formData) {
    var s = this;
    var params = new URLSearchParams(formData);
    params.append('sections[]', 'cart-drawer');
    s._b(true);
    s._fetch(window.theme.routes.cart_add_url + '.js', params)
      .then(function (data) {
        s._r(data.sections);
        s._say('Item added to cart');
        s.open();
      })
      .catch(function () { s._say('Error adding to cart. Please try again.'); })
      .finally(function () { s._b(false); });
  }

  change(key, qty) {
    var s = this;
    s._b(true);
    s._fetch(
      window.theme.routes.cart_change_url + '.js',
      JSON.stringify({ id: key, quantity: qty, sections: ['cart-drawer'] }),
      true
    )
      .then(function (data) {
        s._r(data.sections);
        s._say(data.item_count ? 'Cart updated' : 'Cart is now empty');
      })
      .catch(function (err) {
        console.error('Cart change error:', err);
        s._say('Error updating cart. Please try again.');
      })
      .finally(function () { s._b(false); });
  }

  /* Internal fetch wrapper — json flag sends Content-Type: application/json */
  _fetch(url, body, json) {
    var headers = {};
    if (json) headers['Content-Type'] = 'application/json';
    return fetch(url, { method: 'POST', headers: headers, body: body }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (d) {
          throw new Error(d.description || d.message || 'Request failed');
        });
      }
      return res.json();
    });
  }

  /* Re-render drawer sections returned from the cart API */
  _r(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = html;

    var P = '[data-cart-drawer-';
    var get = function (ctx, name) { return ctx.querySelector(P + name + ']'); };

    var newBody   = get(tmp, 'body');
    var newFooter = get(tmp, 'footer');
    var newCount  = get(tmp, 'count');

    var curBody   = get(this, 'body');
    var curFooter = get(this, 'footer');
    var curCount  = get(this, 'count');

    if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;

    if (curFooter && newFooter) {
      curFooter.innerHTML = newFooter.innerHTML;
      curFooter.style.display = '';
    } else if (curFooter) {
      curFooter.style.display = 'none';
    } else if (newFooter) {
      this._pa.appendChild(newFooter);
    }

    var count = newCount ? newCount.textContent.trim() : '0';
    if (curCount) curCount.textContent = count;

    /* Update all cart count badges across the page */
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = +count > 0 ? '' : 'none';
    });
  }

  _b(busy) {
    if (this._pa) this._pa.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  _say(msg) {
    if (this._lr) this._lr.textContent = msg;
  }
}

customElements.define('cart-drawer', CartDrawer);
